
const marketstackkey = "6472293afaf57688dc0ed3f907a71858"
const tdkey = "ZS8CKW5TX4Y4FAFZYUV7SW7ADSAGGVUR"

export {marketstackkey,tdkey}